import styled from '@emotion/styled';

import { COLOR_DANGER, COLOR_DANGER_BORDER, COLOR_DANGER_SOFT, RADIUS_LG } from './utils/variables';

export const ErrorBanner = styled.div`
  padding: 12px 16px;
  border-radius: ${RADIUS_LG};
  background: ${COLOR_DANGER_SOFT};
  border: 1px solid ${COLOR_DANGER_BORDER};
  color: ${COLOR_DANGER};
  font-size: 14px;
  width: 100%;
`;
